"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ark = require("@dateam/ark");
var _TableRow = _interopRequireDefault(require("./TableRow"));
// import propTypes from 'prop-types';

const TableBody = _ref => {
  let {
    data,
    columns,
    selectedField,
    onRowClick,
    onSelectionChange
  } = _ref;
  const handleRowClick = _react.default.useCallback((rowId, cellIndex, data) => {
    if ((0, _ark.isFunction)(onRowClick)) {
      onRowClick(rowId, cellIndex, data);
    }
  }, [onRowClick]);
  const handleRowSelectionChange = _react.default.useCallback((selected, rowId, data) => {
    if ((0, _ark.isFunction)(onSelectionChange)) {
      onSelectionChange(rowId, data, selected);
    }
  }, [onSelectionChange]);
  const rowChildren = _react.default.useMemo(() => {
    if (!Array.isArray(data)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    return data.map((dataEntry, dataIdx) => /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      key: dataIdx,
      data: dataEntry,
      columns: columns,
      selectedField: selectedField,
      onClick: cellIndex => handleRowClick(dataIdx, cellIndex, dataEntry),
      onSelectionChange: selected => handleRowSelectionChange(selected, dataIdx, dataEntry)
    }));
  }, [data, columns, handleRowClick, handleRowSelectionChange, selectedField]);
  return /*#__PURE__*/_react.default.createElement("tbody", null, rowChildren);
};

// TableBody.propTypes = {
//     data: propTypes.arrayOf(propTypes.any).isRequired,
//     columns: propTypes.arrayOf(propTypes.any).isRequired,
//     selectedField: propTypes.string,
//     onRowClick: propTypes.func,
//     onSelectionChange: propTypes.func
// };

// TableBody.defaultProps = {
//     selectedField: undefined,
//     onRowClick: undefined,
//     onSelectionChange: undefined
// };
var _default = exports.default = TableBody;